import React from 'react';
import { IconBase, IconBaseProps } from './IconBase';

export const Chat: React.FunctionComponent<IconBaseProps> = (props) => (
  <IconBase {...props} viewBox="0 0 20 20">
    <path d="M16,1H4A4,4,0,0,0,0,5v5a4,4,0,0,0,4,4H7.65L14,19.08V14h2a4,4,0,0,0,4-4V5A4,4,0,0,0,16,1Zm2,9a2,2,0,0,1-2,2H12v2.92L8.35,12H4a2,2,0,0,1-2-2V5A2,2,0,0,1,4,3H16a2,2,0,0,1,2,2Z" />
  </IconBase>
);
